import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import performRequest from "../../../api/request";

const tableHead = [
  "Sr.",
  "Name",
  "Contact Number",
  "Enroll Date",
  "Generated By",
  "Actions",
];

const FarmTrainingTable = ({
  data,
  currentPage,
  itemsPerPage,
  showRefundTraining,
  onActionComplete,
}) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/farm-training/view/${id}`);
  };

  // ✅ refund handler
  const handleRefund = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/farmTraining/updateFarmTrainingReqRefund/${id}`,
        {
          refundRequested: true,
        }
      );
      if (res.status === 200) {
        onActionComplete();
      }
    } catch (error) {
      console.log(error); 
    }
  };

  const restoreTraining = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/farmTraining/updateFarmTraining/${id}`,
        { refundRequested: false }
      );
      if (res.status === 200) {
        onActionComplete();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.name || "N/A"}</td>
                <td>{item?.contactNumber || "N/A"}</td>
                <td>{item?.enrollDate || "N/A"}</td>
                <td>{item?.generatedBy || "N/A"}</td>
                <td>
                  <div className="d-flex gap-2">
                    <CustomViewButton onClick={() => goToView(item?.id)} />

                    {!showRefundTraining ? (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleRefund(item?.id)}
                      >
                        Refund
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => restoreTraining(item?.id)}
                      >
                        Restore
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FarmTrainingTable;
